module.exports = __webpack_public_path__ + "img/奖品-艾柱.924b7c34.png";